import React, { useState,useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Logo from '../Image/logo.png';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import { AjouteConfirmation } from '../Api/FinalReservationApi';
import { suprimerOffre } from '../Redux/actions/actionOffre';
import { suprimerReservation } from '../Redux/actions/actionReservation';
import '../Css/confirmation.css';
import db from '../db';

const Confirmation = () => {

    const [show, setShow] = useState(false);
    const [clientData, setClientData] = useState([]);
    const [emailClient, setEmailClient] = useState('');
    const [loading, setLoading] = useState(false);

    let location = useLocation();
    const { state } = useLocation();

    const { idRestaurant, idReservation } = state;
    const [test,setTest] = useState([]);

    let dispatch = useDispatch();
    let navigate = useNavigate();
    const offre = useSelector((state) => state.offre);
    const reservation = useSelector((state) => state.reservation);
  

    const client = useSelector((state) => state.client);

    useEffect(() => {
        const fetchAndSetData = async()=> {
        try {
          const donner = await db.monTableau.toArray();
          if (donner.length > 0) {
            setTest(donner.find((el) => el.id === parseInt(idRestaurant)));
            console.log("Donner dans dexi=>",donner);
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données depuis Dexie :', error);
        }
      };
      fetchAndSetData();
      }, [idRestaurant]);


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    const formatPersonne = (personne) => {
        if (personne > 1) {
            return (<li>Pour {personne} personnes</li>);
        } else {
            return (<li>Pour {personne} personne</li>);
        }
    }

    const handleAddClient = (e) => {
        e.preventDefault();
        var encienEmail = clientData.find((el) => el.email === emailClient);
        if (!encienEmail) {
            setClientData((prev) => [...prev, { id: clientData.length + 1, 'email': emailClient }]);
            setEmailClient('');
        }
    }


    const handleDeleteEmail = (id) => {
        setClientData(clientData.filter((el) => el.id !== id));
    }

    const handleAnnuler = () => {
        setClientData([]);
        setShow(false);
    }

    const handleValider = () => {
        if (clientData.length !== 0) {
            setShow(false);
        } else {
            toast.warning("Email client vide ... !");
        }
    }


    const handleConfirmer = () => {
        setLoading(true);
        const data = { amis: clientData, idRestaurant: idRestaurant, idClient: client.id, idReservation: idReservation };
        AjouteConfirmation(data).then(function (response) {
            console.log(response);
            if (response.data.title === "success") {
                dispatch(suprimerOffre());
                dispatch(suprimerReservation());
                toast.success(response.data.message);
                navigate('/');
            }
        }).catch(function (error) {
            console.log(error);
            if (error) {
                toast.error(error.response.data?.message);
            }

        }).finally(function () {
            setLoading(false);
        });
    }

    const handleCancel = () => {
        navigate('/annulation', { state: { idRestaurant: idRestaurant, idReservation: idReservation } });
    }


    return (
        <div>
            <Helmet>
                <title>Confirmation</title>
                <meta name='description' content='Confirmation réservation' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='confirmation'>
                <div className='confirmation_content'>
                    <div className='confirmation_header'>
                        <h1>Bonjour <span>{client.nom} {client.prenom}</span></h1>
                        <div> <span>Merci pour votre réservation</span></div>
                        <div> <span>Profitez-en bien et pensez à deposer votre davis après votre répas !</span></div>
                    </div>
                    <div className='confirmation_body'>
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7'>
                                <div className='confirmation_recap'>
                                    <span>Récapitulatif de la réservation N° {idReservation}</span>
                                    <h2>Réservation confirmée :</h2>
                                    <ul>
                                        <li>Le {reservation.date} à {reservation.heure}</li>
                                        {formatPersonne(reservation.personne)}
                                        {offre.length !== 0 ?
                                            <li>{offre.libelle}</li>
                                            : ''}
                                    </ul>
                                </div>
                            </div>
                            <div className='col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                <div className='confirmation_resto'>
                                    <Link to={`/restoPage/${test.id}`} title="restaurant page"> <div className='confirmation_photoResto'>
                                        <img src={test?.photos? test?.photos[0]?.basePhoto : ""} alt="avatar restaurant" />
                                    </div></Link>
                                    <div className='confirmation_description_resto'>
                                        <Link to={`/restoPage/${test.id}`} title="restaurant page" className='nom_lien'> <h2>{test.nomRestaurant}</h2></Link>
                                        <div><span>Adresse Mahamasina</span></div>
                                        {test.precision !== "" ?
                                            <div><span>Précision sur l'adresse : {test.precision}</span></div>
                                            : ''}
                                        <div><span>N° téléphone {test.telephone}</span></div>
                                        <div className='d-flex justify-content-between btn_valideconfirmation'>
                                            <button className='btn btn_annuller' onClick={handleCancel}>Annuler la réservations</button>
                                            <button className='btn btn_ajouteClient' onClick={handleShow}>Ajouter des clients</button>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center'>
                                    {loading ? <Button className='btn btn_confirmReservation' disabled>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            variant="info"
                                            className="spiner"
                                        />
                                        Loading...
                                    </Button> : <button className='btn btn_confirmer' onClick={handleConfirmer}>Confirmer la réservations</button>}

                                </div>
                            </div>
                        </div>
                        <div className='conseils'>
                            <h3>Quelques conseils :</h3>
                            <ul>
                                <li>Votre table vous attend, inutile d’appeler le restaurant !</li>
                                <li>Par contre si vous pensez avoir plus de 15 min de retard, pensez à prévenir le restaurant avant qu’il ne propose votre table à un autre client !</li>
                                <li>Et si imprévu ou changement d’avis, n’oubliez pas d’annuler votre réservation – via votre compte ou directement auprès du restaurant, pour permettre à d’autres d’en profiter !</li>
                            </ul>
                        </div>
                        <div className='merci'>
                            <div className="logo">
                                <img src={Logo} alt="logo restaurant" width="80px" />
                            </div>
                            <p>A bientôt et comptez sur nous pour votre prochain restaurant ! Toute l’équipe vous remercie ! </p>
                        </div>
                        <p className="version">Version 1</p>
                        <Modal
                            show={show}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={false}
                            centered
                        >
                            <Modal.Body>
                                <div className='modal_ajouteClient'>
                                    <div className='header_ajouteClient'>
                                        <h3>Ajouter des clients</h3>
                                        <i className='fa fa-close' onClick={handleClose}></i>
                                    </div>

                                    <div className='body_ajouteClient'>
                                        <form onSubmit={handleAddClient}>
                                            <div className='form_ajouteClient'>
                                                <input type="email" value={emailClient} onChange={(e) => setEmailClient(e.target.value)} className="form-control" required id="exampleFormControlInput1" placeholder="Adresse email client ..." />
                                                <button type="submit" className='btn btn_fa-plus-circle'><i className='fa fa-plus-circle'></i></button>
                                            </div>
                                        </form>
                                        <div className='liste_client'>
                                            {clientData.length !== 0 ?
                                                clientData.map((item, index) => {
                                                    return (<div className='item_listeClient' key={index}>
                                                        <span>{item.email}</span>
                                                        <i className='fa fa-trash-o' onClick={() => handleDeleteEmail(item.id)}></i>
                                                    </div>)
                                                })
                                                : ''}

                                        </div>
                                        <div className='valide_ajouteClient'>
                                            <button className='btn annuler_ajouteClient' onClick={handleAnnuler}>Annuler</button>
                                            <button className='btn valider_ajouteClient' onClick={handleValider}>Valider</button>
                                        </div>
                                    </div>

                                </div>

                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Confirmation;